import {BaseCircle, BaseMap, BaseMarker} from './map-models';

class GoogleMap extends BaseMap {
    constructor(el, options, headers) {
        super(el, options);
        this.initCommonMapOptions(options);
        if (allowRenderMap(headers)) {
            this._map = new google.maps.Map(el, options);
        } else {
            this._map = new BaseMap();
        }
    }

    initCommonMapOptions(options) {
        const noPoiStyle = [{
            featureType: 'poi',
            stylers: [{ visibility: 'off' }],
        }];

        Object.assign(options, {
            styles: noPoiStyle,
            clickableIcons: false,
            fullscreenControl: false,
            streetViewControl: false,
            cameraControl: false,
            zoomControl: true,
            scrollWheel: true,
            gestureHandling: 'greedy',
        });
    }

    // TODO: should be removed in future, used for marker clusterer
    getInternalMap() {
        return this._map;
    }

    clearListeners(eventName) {
        google.maps.event.clearListeners(this._map, eventName);
    }

    addListener(eventName, handler) {
        this._map.addListener(eventName, handler);
    }

    getCenter() {
        return this._map.getCenter();
    }

    setCenter(location) {
        this._map.setCenter(location);
    }

    getBounds() {
        return this._map.getBounds();
    }

    getBoundsArray() {
        const bounds = this._map.getBounds();
        return bounds ? Object.values(bounds.toJSON()) : null;
    }

    fitBounds(viewPort) {
        this._map.fitBounds(viewPort, 0);
    }

    getZoom() {
        return this._map.getZoom();
    }

    setZoom(zoom) {
        this._map.setZoom(zoom);
    }

    createMarker(markerOptions) {
        return new GoogleMarker(this._map, markerOptions);
    }

    createCircle(marker, circleOptions) {
        return new GoogleCircle(this._map, marker, circleOptions);
    }

    setMapToMarker(marker) {
        marker.setMap(this._map);
    }

    getViewPort(boundsArray) {
        if (boundsArray && boundsArray.length === 4) {
            const sw = new google.maps.LatLng(boundsArray[0], boundsArray[1]);
            const ne = new google.maps.LatLng(boundsArray[2], boundsArray[3]);
            return new google.maps.LatLngBounds(sw, ne);
        }

        return null;
    }
}

class GoogleMarker extends BaseMarker {
    constructor(map, options) {
        super(map, options);
        if (map instanceof BaseMap) {
            this._marker = new BaseMarker();
        } else {
            options = Object.assign({}, options, {map});
            this._marker = new google.maps.Marker(options);
        }
    }

    setMap(map) {
        this._marker.setMap(map);
    }

    resetMap() {
        this.setMap(null);
    }

    getPosition() {
        return this._marker.getPosition();
    }

    setPosition(location) {
        this._marker.setPosition(location);
    }

    addListener(eventName, handler) {
        this._marker.addListener(eventName, handler);
    }

    setAnimation(animation) {
        this._marker.setAnimation(animation);
    }
}

class GoogleCircle extends BaseCircle {
    constructor(map, marker, options) {
        super(map, marker, options);
        this._marker = marker;
        if (marker instanceof BaseMarker) {
            this._circle = new BaseCircle();
        } else {
            options = Object.assign({}, options, {map});
            this._circle = new google.maps.Circle(options);
        }
    }

    bindTo(center, position) {
        this._circle.bindTo(center, this._marker, position);
    }

    setRadius(circleRadius) {
        this._circle.setRadius(circleRadius);
    }

    getBounds() {
        return this._circle.getBounds();
    }
}

const allowRenderMap = (headers) => {
    return !window.navigator.userAgent.includes('cypress') || (headers != null && headers['Force-Map-Load'] != null);
};

export {GoogleMap, GoogleMarker, allowRenderMap};
